import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { Link } from 'react-router-dom';

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

const About = () => {
  return (
    <section className="bg-gradient-to-b from-gray-50 to-white py-16 md:py-20 lg:py-24 relative overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 relative">
        
        {/* Main Content */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.15 }}
          transition={{ staggerChildren: 0.25 }}
          className="space-y-20 lg:space-y-32 relative z-10"
        >
          
          {/* ========== SECTION 1: About SecurXpert ========== */}
          <motion.div
            variants={fadeInUp}
            className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 xl:gap-16 items-center"
          >
            {/* Image Left */}
            <div className="w-full order-2 lg:order-1">
              <div className="relative rounded-tr-[60px] overflow-hidden shadow-2xl group">
                <img
                  src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&h=600&fit=crop"
                  alt="About SecurXpert Team"
                  className="w-full h-[320px] sm:h-[400px] lg:h-[480px] xl:h-[520px] object-cover transform group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent"></div>
              </div>
            </div>

            {/* Content Right */}
            <div className="w-full space-y-5 order-1 lg:order-2">
              <div className="inline-block">
                <p className="text-xxxl sm:text-3xl font-bold text-gray-500 uppercase tracking-widest">
                  About SecurXpert
                </p>
              </div>
              
              <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-gray-900 leading-[1.15]">
                Empowering Smarter Digital Solutions
              </h2>
              
              <div className="space-y-4 text-gray-600">
                <p className="text-base sm:text-lg leading-relaxed">
                  At <span className="font-semibold text-blue-600">SecurXpert Technologies</span>, 
                 we focus on making technology simple and effective for businesses. We provide everything in one place software development, cloud services, digital marketing and skill-based training. Known as a leading software development company in Hyderabad, our dedicated team and client-first approach help startups and enterprises grow through digital transformation and long-term success
                </p>
              </div>

              <div className="pt-3">
                <Link
  to="/who-we-are"
  className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-3 rounded-lg text-base transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-0.5 inline-block" // Note: Added 'inline-block' to make 'Link' behave like a block/button element for proper padding/styling
>
  Learn More
</Link>
              </div>
            </div>
          </motion.div>

          {/* ========== SECTION 2: Why Choose SecurXperts ========== */}
          <motion.div
            variants={fadeInUp}
            className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 xl:gap-16 items-center"
          >
            {/* Content Left */}
            <div className="w-full space-y-5 order-1">
              <div className="inline-block">
                <p className="text-xs sm:text-3xl font-bold text-gray-500 uppercase tracking-widest">
                  Company Benefits
                </p>
              </div>
              
              <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-gray-900 leading-[1.15]">
                Why Choose SecurXperts?
              </h2>
              
              <div className="space-y-4 text-gray-600">
                <p className="text-base sm:text-lg leading-relaxed">
                  At SecurXpert Technologies, we don’t just support your business; we accelerate it. We are your all-in-one digital powerhouse, blending cutting-edge security with smart IT solutions to drive real growth. Whether you need custom software, robust cloud infrastructure, impactful digital marketing, or industry-ready training, we have you covered.
                </p>
                
                <p className="text-base sm:text-lg leading-relaxed">
                  Your Vision. Our Expertise. Limitless Possibilities.
 
                </p>
              </div>

              {/* Benefits Grid */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2">
                {[
                  { text: "Innovation" },
                  { text: "Security" },
                  { text: "Smart Technology" },
                  { text: "Client-First Approach" },
                ].map((item, idx) => (
                  <div key={idx} className="flex items-center gap-3">
                    <div className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-600 flex items-center justify-center shadow-md">
                      <Check className="w-4 h-4 text-white" strokeWidth={3} />
                    </div>
                    <span className="text-gray-800 font-semibold text-base">
                      {item.text}
                    </span>
                  </div>
                ))}
              </div>

              <div className="pt-3">
                <Link
  to="/who-we-are"
  className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-3 rounded-lg text-base transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-0.5 inline-block" // Note: Added 'inline-block' to make 'Link' behave like a block/button element for proper padding/styling
>
  Learn More
</Link>
              </div>
            </div>

            {/* Image Right */}
            <div className="w-full order-2">
              <div className="relative rounded-tl-[60px] overflow-hidden shadow-2xl group">
                <img
                  src="https://images.unsplash.com/photo-1551434678-e076c223a692?w=800&h=600&fit=crop"
                  alt="Why Choose Us"
                  className="w-full h-[320px] sm:h-[400px] lg:h-[480px] xl:h-[520px] object-cover transform group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent"></div>
              </div>
            </div>
          </motion.div>

        </motion.div>
      </div>
    </section>
  );
};

export default About;